import { FC } from 'react'
import { SpeakerMaxIcon } from '@/atoms/Icons/SpeakerMaxIcon'
import { SpeakerMuteIcon } from '@/atoms/Icons/SpeakerMuteIcon'
import { VisualOffIcon } from '@/atoms/Icons/VisualOffIcon'
import { VisualOnIcon } from '@/atoms/Icons/VisualOnIcon'
import { IconColor } from '@/atoms/utils/IconTypes'
import { SkipCategoryType } from '@/services/ParentalControlsService/ParentalControlsService'

interface CategoryIconProps {
  type: SkipCategoryType
  isMuted: boolean
  size: number
  color: IconColor
}

export const CategoryIcon: FC<CategoryIconProps> = ({ type, isMuted, size, color }) => {
  if (type === SkipCategoryType.Visual) {
    return isMuted ? <VisualOffIcon size={size} color={color} /> : <VisualOnIcon size={size} color={color} />
  }
  return isMuted ? <SpeakerMuteIcon size={size} color={color} /> : <SpeakerMaxIcon size={size} color={color} />
}
